import React from "react";
import styled from "@emotion/styled";
import { Box, IconButton, Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import AppText from "@common/component/AppText";

const Container = styled.div<{ width?: string | number }>(
  ({ width }) => `
  width: ${width ?? "459px"};
  background-color: white;
  height: 100%;
  margin-left: auto;
  outline: none;
  display: flex;
  flex-direction: column;
`
);

const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  padding: 24px;
  padding-top: 40px;
  justify-content: space-between;
  align-items: center;
`;

const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  border-top: 1px solid #e8e8e8;
  padding: 32px 24px;
`;

interface SideModalProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  children: React.ReactNode;
  width?: number | string;
}

const SideModal: React.FC<SideModalProps> = ({ open, width, onClose, title, children }) => (
  <Modal open={open} onClose={(_, reason) => (reason === "backdropClick" ? onClose?.() : null)}>
    <Container width={width}>
      <Header>
        {title && (
          <AppText fontSize={22} fontFamily="semibold">
            {title}
          </AppText>
        )}
        <IconButton onClick={onClose} size="medium">
          <Close />
        </IconButton>
      </Header>
      <ContentContainer>{children}</ContentContainer>
    </Container>
  </Modal>
);

export default SideModal;
